import { render, staticRenderFns } from "./GroupRadioInput.vue?vue&type=template&id=2f2700d8&"
import script from "./GroupRadioInput.vue?vue&type=script&lang=js&"
export * from "./GroupRadioInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports